import { isProduction } from './isProduction'
import { QueryField } from './telegramBot'

export const connectChannelToSiteByCode: QueryField = 'подключить_канал_к_сайту_по_коду'
export const vinglaServiceBotUserName = isProduction ? 'uvedomleniya_ot_sajta_bot' : 'test_target22_bot'
export const vinglaGiftBotUserName = isProduction ? 'distribution_vingla_bot' : 'gift_1111_bot'
